import React, { Component } from 'react'
import {connect} from 'react-redux'
import MultiLangText from '../multilang/MultiLangText'
import {TimelineMax} from 'gsap'
class LegalPopUp extends Component {


  constructor(props){
      super()
      this.state = {
        open:false,
        open_tl:undefined,
        language:'LONDON'
      }
    this.openPopUp = this.openPopUp.bind(this);
    this.closePopUp = this.closePopUp.bind(this)
    this.setUpOpenAnimation = this.setUpOpenAnimation.bind(this)
    this.switchLanguage = this.switchLanguage.bind(this)
    this.checkForLineBreaks = this.checkForLineBreaks.bind(this)
    this.checkIfTitleIsTooLong = this.checkIfTitleIsTooLong.bind(this)
  }

  openPopUp(){
    this.setState({open:true})
    //this.setUpOpenAnimation();

    window.location.hash = 'popup='+this.props.slug




  }

  componentDidMount(){
      if(window.location.hash==='#popup='+this.props.slug){
            this.setState({open:true})
      }
  }

  componentDidUpdate(prevProps,prevState){
      //if((!prevProps.currentCareer && this.props.currentCareer)){
      //console.log('Open?',prevProps.open , this.props.open);
      if(!prevState.open && this.state.open){
        this.setUpOpenAnimation();

      }

      if(this.state.open){
        this.checkForLineBreaks();
        this.checkIfTitleIsTooLong();
        }
  }



  checkForLineBreaks(){

    let languages = this.refs.versionSwitch.querySelectorAll('li')
    let lastY


    for(let i=0; i < languages.length;i++){
      //languages[i].classList.remove('last-in-line')
    }

    for(let i=0; i < languages.length;i++){


        if(lastY && languages[i].getBoundingClientRect().top !== lastY ){
          languages[i-1].classList.add('last-in-line')
        }else{
          //languages[i].classList.remove('last-in-line')
        }

        lastY = languages[i].getBoundingClientRect().top
    }
  }


  checkIfTitleIsTooLong(){
      let title = this.refs.title.querySelector('span')

      title.classList.remove('long-word')
      //console.log(title.getBoundingClientRect().width);
      if(title.offsetWidth>window.innerWidth-80){
          title.classList.add('long-word')
      }


  }


  setUpOpenAnimation(){

      let open_tl = new TimelineMax({repeat:0})

      console.log("Play opening");

        open_tl.add(()=>{
            if(this.state.isClosing){
              this.setState({open:false,isClosing:false})
              this.state.open_tl.kill();
            }
        })

        open_tl.fromTo(this.refs.container, .5, {alpha:0},{alpha:1})
        open_tl.fromTo(this.refs.title, .5, {alpha:0},{alpha:1})
        open_tl.fromTo(this.refs.line, .5, {width:0},{width:60})
        open_tl.fromTo(this.refs.versionSwitch, .5, {alpha:0},{alpha:1})
        open_tl.fromTo(this.refs.bodyCopy, .5,{alpha:0},{alpha:1})
        open_tl.fromTo(this.refs.close, .5,{alpha:0},{alpha:1},'-=.5')
      //  open_tl.fromTo(this.refs.gradient, 2, {top:'-100%'},{top:'100%'})


        open_tl.add(()=>{
          //this.enableHeader();
        })

        this.setState({open_tl})

        //open_tl.from(this.refs.col2, .5, {alpha:0},'-=.5')
        //open_tl.pause();

  }
  closePopUp(){

        this.state.open_tl.timeScale(3)
        this.state.open_tl.reverse()
        this.setState({isClosing:true})

        if(window.history.replaceState){
          console.log('Remove Hash');
          var noHashURL = window.location.href.replace(/#.*$/, '');
          window.history.replaceState('', document.title, noHashURL)
        }

  }

  legalPage(){

    let slug = this.props.slug

    return this.props.pagesData.data.filter((item)=>{
      //  console.log(item.slug,slug);
      return (item.slug===slug)
    })[0]
  }

  switchLanguage(iso){

      this.setState({language:iso})
      /*
      this.checkForLineBreaks();
      setTimeout(()=>{
        this.checkForLineBreaks();
      },10)
      setTimeout(()=>{
        this.checkForLineBreaks();
      },100) */
  }


  render() {


    const content = this.legalPage();



    let title = content.acf.page_title[this.state.language]
    let bodyCopy = content.acf.body_copy[this.state.language]

    //console.log('title',this.state);
    //console.log('bodyCopy',bodyCopy);

    //BRUNNEN  |  BUDAPEST  |  FRANKFURT  |  LONDON  |  LOS ANGELES  |  MADRID  |  MILANO  |  OBERHOFEN


    return(

      <div className="legal-link">
        <div>
            {this.state.open?
                <div className="legal-pop-up" ref="container">
                  <div className="inner-legal">
                    <div className="title">
                      <h1 ref="title" ><span style={{display:'inline-block'}} dangerouslySetInnerHTML={{__html:title}}></span></h1>
                      <div ref="line" className="line" />
                    </div>

                    <div className="version-switch" ref="versionSwitch">
                          <ul>
                              <li onClick={()=>this.switchLanguage('BAAR')} className={(this.state.language === 'BAAR')? 'active' : ''}>BRUNNEN</li>
                              <li onClick={()=>this.switchLanguage('BUDAPEST')} className={(this.state.language === 'BUDAPEST')? 'active' : ''}>BUDAPEST</li>
                              <li onClick={()=>this.switchLanguage('FRANKFURT')} className={(this.state.language === 'FRANKFURT')? 'active' : ''}>FRANKFURT</li>
                              <li onClick={()=>this.switchLanguage('LONDON')} className={(this.state.language === 'LONDON')? 'active' : ''}>LONDON</li>
                              <li onClick={()=>this.switchLanguage('LOSANGELES')} className={(this.state.language === 'LOSANGELES')? 'active' : ''}>LOS ANGELES</li>
                              <li onClick={()=>this.switchLanguage('MADRID')} className={(this.state.language === 'MADRID')? 'active' : ''}>MADRID</li>
                              <li onClick={()=>this.switchLanguage('MILANO')} className={(this.state.language === 'MILANO')? 'active' : ''}>MILANO</li>
                              <li onClick={()=>this.switchLanguage('OBERHOFEN')} className={(this.state.language === 'OBERHOFEN')? 'active' : ''}>OBERHOFEN</li>
                          </ul>
                    </div>

                    <div className="legal-body-copy" ref="bodyCopy" >
                      <div dangerouslySetInnerHTML={{__html:bodyCopy}}>
                      </div>
                    </div>

                    <div className="close-button" ref="close" onClick={this.closePopUp}>
                      <div className="close-line" />
                      <div className="close-line" />
                    </div>
                  </div>

                </div>

            : null}
        </div>
        <div className="legal-pop-up-link" onClick={this.openPopUp}>
          {this.props.children}
        </div>
    </div>
    )
  }
}

const mapStateToProps = (state)=>{
  let pagesData = state.KastnerStore.pagesData
  return {
      pagesData
    }
}

export default connect(mapStateToProps)(LegalPopUp)



// WEBPACK FOOTER //
// ./src/modules/pages/LegalPopUp.js